<template>
  <div class="flex flex-col w-full">
    <button class="relative flex text-center items-center  flex-col p-2 bg-white hover:bg-trader-blue hover:text-white" :class="{ 'hover:bg-trader-light-gray': props.isLoading }"
        :disabled="props.isLoading"  @click="clickEvent()">
      {{ props.textTitle }}
    </button>
    <div v-if="props.isLoading" class="flex items-center justify-center mt-2">
      <Spinner />
    </div>
  </div>
</template>

<script setup lang="ts">
import { defineProps } from 'vue'
import Spinner from "@/components/Base/Spinner.vue";

const props = defineProps({
  isLoading: {
    type: Boolean,
    default: false
  },
  textTitle: {
    type: String,
    default: 'Speichern'
  },
  clickEvent: {
    type: Function,
    required: true
  }
})

</script>
